document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  cartOpeners.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });

  cartClosers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // ---- promo popup dismiss (persists for the session) ----
  var popup = document.getElementById('promo-popup');
  var popupCloseBtn = document.querySelector('[data-promo-close]');

  if (popup) {
    if (sessionStorage.getItem('wraith_promo_dismissed') === '1') {
      popup.classList.add('is-hidden');
    }
    if (popupCloseBtn) {
      popupCloseBtn.addEventListener('click', function () {
        popup.classList.add('is-hidden');
        sessionStorage.setItem('wraith_promo_dismissed', '1');
      });
    }
  }

  // ---- AJAX add to cart on product forms ----
  var productForms = document.querySelectorAll('form[action^="/cart/add"]');
  productForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var cartCountEls = document.querySelectorAll('.site-header__cart');
          cartCountEls.forEach(function (el) {
            el.textContent = 'cart(' + cart.item_count + ')';
          });
          openCart();
          // Refresh drawer contents by reloading the cart section markup
          fetch(window.location.pathname)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var newDrawer = doc.getElementById('cart-drawer');
              if (newDrawer) {
                cartDrawer.querySelector('.cart-drawer__items').innerHTML = newDrawer.querySelector('.cart-drawer__items').innerHTML;
                var newFooter = newDrawer.querySelector('.cart-drawer__footer');
                var oldFooter = cartDrawer.querySelector('.cart-drawer__footer');
                if (newFooter && oldFooter) {
                  oldFooter.outerHTML = newFooter.outerHTML;
                } else if (newFooter) {
                  cartDrawer.querySelector('.cart-drawer__panel').appendChild(newFooter);
                }
              }
            });
        })
        .catch(function (err) {
          console.error('wraith: add to cart failed', err);
          form.submit();
        });
    });
  });

  // ---- product page thumbnail swap ----
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImage = document.querySelector('.product-page__image');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var thumbImg = thumb.querySelector('img');
      if (mainImage && thumbImg) mainImage.src = thumbImg.src.replace('width=200', 'width=1200');
    });
  });
});
